import { contains } from 'ramda';

import accountsTemplate from './accounts.tpl.html';
import { getUsers, getTotalUsers, isLoading, getReviewingUsers } from '../../reducers/users';

export class Accounts {
  constructor($scope, $ngRedux, actionsFactory, $translate, $state,
    companiesService, configService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      $state,
      companiesService,
      configService,
      validateEmail: Accounts.validateEmail,
      searchColumns: [
        {
          type: 'text',
          id: 'name',
          labelKey: 'TABLE_HEADER_NAME',
          fields: ['firstName', 'lastName'],
          sortable: true,
          width: '18%',
        },
        {
          type: 'boolean',
          id: 'status',
          labelKey: 'TABLE_HEADER_STATUS',
          booleanKey: (column, element) => element.status === 'approved',
          transform: (column, element) => $translate.instant(`STATUS_${element.status.toUpperCase()}`),
          width: '13%',
        },
        {
          type: 'boolean',
          id: 'status',
          labelKey: 'TABLE_HEADER_ACTIVE',
          booleanKey: 'active',
          transform: () => '',
          width: '7%',
        },
        {
          type: 'text',
          id: 'company',
          labelKey: 'TABLE_HEADER_COMPANY',
          fields: ['company.name'],
          nestedProp: 'name',
          width: '18%',
        },
        {
          type: 'text',
          id: 'type',
          labelKey: 'TABLE_HEADER_ACCOUNT_TYPE',
          transform: (column, element) => $translate.instant(`ACCOUNT_TYPE_${element.type.toUpperCase()}`),
          width: '9%',
        },
        {
          type: 'text',
          id: 'added_by_user',
          labelKey: 'TABLE_HEADER_INSERTED_BY',
          fields: ['addedByUser.firstName', 'addedByUser.lastName'],
          width: '20%',
        },
        {
          type: 'button',
          id: 'gotodetail',
          cssClass: 'tct-icon tct-icon__mail',
          width: '5%',
          showElement: element => !element.active,
          onClick: id => this.resendAccountActivationEmailStart(id),
        },
        {
          type: 'button',
          id: 'editaccount',
          cssClass: 'tct-icon tct-icon__edit',
          width: '5%',
          onClick: id => this.doShowEditUserModal(id),
        },
        {
          type: 'button',
          id: 'removeaccount',
          cssClass: 'tct-icon tct-icon__remove ',
          width: '5%',
          onClick: id => this.doShowRemoveUserModal(id),
        },
      ],
      searchParams: [
        {
          searchKey: 'GENERIC_NAME',
          type: 'input',
          input: '',
          id: 'name',
        },
        {
          searchKey: 'GENERIC_COMPANY',
          type: 'input',
          input: '',
          id: 'company',
        },
        {
          searchKey: 'GENERIC_USERTYPE',
          input: '',
          id: 'roles',
          type: 'select',
          options: [
            { value: 'masters', key: 'GENERIC_MASTER' },
            { value: 'directors', key: 'GENERIC_DIRECTOR' },
            { value: 'buyers', key: 'GENERIC_BUYER' },
            { value: 'bases', key: 'GENERIC_BASE' },
            { value: '', key: 'GENERIC_ANY' },
          ],
        },
        {
          searchKey: 'GENERIC_REGISTRATIONSTATUS',
          input: '',
          id: 'status',
          type: 'select',
          options: [
            { value: 'active', key: 'GENERIC_ACTIVE' },
            { value: 'inactive', key: 'GENERIC_NOT_ACTIVE' },
            { value: '', key: 'GENERIC_ANY' },
          ],
        },
      ],
    });
    const unsubscribe = $ngRedux.connect(Accounts.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }

  $onInit() {
    this.isClients = (this.$state.params.clients === 'true');
    this.isEditorView = (this.$state.params.editor === 'true');
    this.showModal = false;
    this.modalRefuse = false;
    this.modalConfirm = false;
    this.newUser = { };
    this.actualSort = '';
    this.newUserCompany = {};
    this.showEditUserModal = false;
    this.showRemoveUserModal = false;
    this.userToEdit = {};
    this.userToRemove = {};

    this.search = {
      name: '',
      company: '',
      roles: '',
      status: '',
    };

    this.sort = {
      name: '',
      company: '',
      status: '',
      role: '',
    };

    this.paramList = {
      sort: this.sort,
      search: this.search,
    };

    if (this.isLoggedInUserOfType(['editor'])) {
      this.reqReviewing(this.isClients);
    }

    this.searchAccounts(this.paramList);
  }

  searchAccounts(paramList) {
    if (this.isEditorView) {
      this.reqEditorUserListStart(paramList);
    } else if (this.isClients) {
      this.reqClientUserListStart(paramList);
    } else {
      this.reqNonClientUserListStart(paramList);
    }
  }

  getCreateAccountModalTitle(type) {
    const userType = this.getAccountTypeDescription(type);
    return this.$translate.instant('MODAL_TITLE_CREATE_ACCOUNT', {
      userType: userType.toUpperCase(),
    });
  }

  getAccountTypeDescription(type) {
    return this.$translate.instant(`ACCOUNT_TYPE_${type && type.toUpperCase()}`);
  }

  static mapStateToThis(state) {
    return {
      users: {
        items: getUsers(state),
        total: getTotalUsers(state),
        isLoading: isLoading(state),
      },
      reviewingUsers: {
        items: getReviewingUsers(state),
      },
      me: state.authentication.user,
    };
  }

  refuse(user) {
    this.showModalNotify = true;
    this.modalUser = user;
    this.isModalConfirm = false;
  }

  accept(user) {
    this.showModalNotify = true;
    this.modalUser = user;
    this.isModalConfirm = true;
  }

  closeAllModals() {
    this.showModalNotify = false;
    this.showModalAdd = false;
    this.modalUser = false;
    // clearing forms
    this.newUserCompany = {};
    this.newUser = {};
    this.reasonRefuse = '';
  }

  isLoggedInUserOfType(types) {
    return contains(this.me.type, types);
  }

  refuseConfirm() {
    this.refuseUser(this.modalUser, this.reasonRefuse);
    // this.closeAllModals();
  }

  acceptConfirm() {
    this.acceptUser(this.modalUser);
    // this.closeAllModals();
  }

  showAddModal(type) {
    this.newUser.type = type;
    this.showModalAdd = true;
  }

  confirmAddModal() {
    this.addUser(this.newUser);
  }

  companySelected(item) {
    if (item && item.item) {
      this.newUser.companyId = item.item.id;
    }
  }

  disableAdd() {
    const result = !this.newUser.firstName ||
      !this.newUser.lastName ||
      !this.validateEmail(this.newUser.email) ||
      (!this.newUser.companyId && this.newUser.type !== 'editor' && this.isLoggedInUserOfType(['editor']));
    return result;
  }

  getTitleString() {
    let str;
    if (this.isEditorView) {
      str = 'ACCOUNTS_TITLE3';
    } else if (!this.isEditorView && !this.isClients) {
      str = 'ACCOUNTS_TITLE2';
    } else if (!this.isEditorView && this.isClients) {
      str = 'ACCOUNTS_TITLE';
    }
    return str;
  }

  doShowEditUserModal(id) {
    this.userToEdit = Object.assign({}, this.users.items.find(user => user.id === id));
    this.showEditUserModal = true;
  }

  doShowRemoveUserModal(id) {
    this.userToRemove = Object.assign({}, this.users.items.find(user => user.id === id));
    this.showRemoveUserModal = true;
  }

  closeEditUserModal() {
    this.showEditUserModal = false;
    this.userToEdit = {};
  }

  closeRemoveUserModal() {
    this.showRemoveUserModal = false;
    this.userToRemove = {};
  }

  editUser() {
    this.editUserStart(this.userToEdit);
    this.showEditUserModal = false;
    this.userToEdit = {};
  }

  removeUser() {
    this.removeUserStart(this.userToRemove);
    this.showRemoveUserModal = false;
    this.userToRemove = {};
  }

  static validateEmail(email) {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; // eslint-disable-line
    return re.test(String(email).toLowerCase());
  }
}

Accounts.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  '$state',
  'companiesService',
  'configService',
];

export const accounts = {
  template: accountsTemplate,
  controller: Accounts,
};
